(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["often-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('often-video-player')) {
  customElements.define('often-video-player', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const button = this.querySelector('button');
      if (!button) return;
      this.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const id = this.dataset.videoId;
        const provider = this.dataset.provider;
        if (!id || !['youtube', 'vimeo'].includes(provider)) return;
        const frame = document.createElement('iframe');
        frame.src = provider === 'youtube' ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0` : `https://player.vimeo.com/video/${encodeURIComponent(id)}?dnt=1`;
        frame.title = this.dataset.title;
        frame.loading = 'lazy';
        frame.allow = 'fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(frame);
        frame.focus();
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["often-rooftop-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('often-rooftop-video')) {
  customElements.define('often-rooftop-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const button = this.querySelector('button');
      if (!button) return;
      this.dataset.initialized = 'true';
      const poster = this.querySelector('img[data-fallback]');
      if (poster) {
        const useFallback = () => {
          const fallback = poster.dataset.fallback;
          if (!fallback) return;
          delete poster.dataset.fallback;
          poster.src = fallback;
        };
        poster.addEventListener('error', useFallback, { once: true });
        if (poster.complete && poster.naturalWidth === 0) useFallback();
      }
      button.addEventListener('click', () => {
        const id = this.dataset.videoId;
        const provider = this.dataset.provider;
        if (!id || !['youtube', 'vimeo'].includes(provider)) return;
        const frame = document.createElement('iframe');
        frame.src = provider === 'youtube' ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0&autoplay=1` : `https://player.vimeo.com/video/${encodeURIComponent(id)}?dnt=1&autoplay=1`;
        frame.title = this.dataset.title;
        frame.loading = 'lazy';
        frame.allow = 'autoplay; fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(frame);
        frame.focus();
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yerka-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yerka-size-finder')) {
    customElements.define('yerka-size-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const form = this.querySelector('form');
        const data = this.querySelector('script[type="application/json"]');
        if (!form || !data) return;
        let config;
        try { config = JSON.parse(data.textContent); } catch (error) { return; }
        if (!Array.isArray(config.sizes) || !config.sizes.length) return;
        this.initialized = true;
        form.hidden = false;
        const height = form.elements.height;
        const inseam = form.elements.inseam;
        const result = this.querySelector('[role="status"]');
        const clearError = () => { inseam.setCustomValidity(''); result.replaceChildren(); };
        height.addEventListener('input', clearError);
        inseam.addEventListener('input', clearError);
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          inseam.setCustomValidity('');
          if (!form.reportValidity()) return;
          const riderHeight = Number(height.value);
          const hasInseam = inseam.value !== '';
          const riderInseam = hasInseam ? Number(inseam.value) : null;
          result.replaceChildren();
          if (hasInseam && riderInseam >= riderHeight) {
            inseam.setCustomValidity(config.invalidInseam);
            result.textContent = config.invalidInseam;
            inseam.reportValidity();
            return;
          }
          const matches = config.sizes.filter(size => riderHeight >= Number(size.minHeight) && riderHeight <= Number(size.maxHeight) && (!hasInseam || riderInseam >= Number(size.minInseam)));
          if (!matches.length) {
            result.textContent = config.none;
          } else {
            const heading = document.createElement('p');
            heading.textContent = config.matches;
            result.append(heading);
            const list = document.createElement('ul');
            matches.forEach(size => {
              const item = document.createElement('li');
              item.textContent = `${size.label} — ${config.minimum}: ${size.minInseam} cm`;
              list.append(item);
            });
            result.append(list);
            if (!hasInseam) {
              const guidance = document.createElement('p');
              guidance.textContent = config.missingInseam;
              result.append(guidance);
            }
          }
          result.focus({ preventScroll: true });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
